import { render } from "./StorePurchaseLimitCaution.vue?vue&type=template&id=7f2d2365&scoped=true"
import script from "./StorePurchaseLimitCaution.vue?vue&type=script&lang=js"
export * from "./StorePurchaseLimitCaution.vue?vue&type=script&lang=js"

import "./StorePurchaseLimitCaution.vue?vue&type=style&index=0&id=7f2d2365&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f2d2365"

export default script